//#region src/dom/predicates.ts
/** @internal */
function isDocument(value) {
	return value instanceof Node && value.nodeType === 9;
}
/** @internal */
function isShadowRoot(value) {
	return value instanceof Node && value.nodeType === 11 && "host" in value;
}
/** @internal */
function isHTMLVideoElement(value) {
	return value instanceof HTMLVideoElement;
}
/** @internal */
function isHTMLAudioElement(value) {
	return value instanceof HTMLAudioElement;
}
/** @internal */
function isHTMLMediaElement(value) {
	return value instanceof HTMLMediaElement;
}
/** @internal */
function isHTMLImageElement(value) {
	return value instanceof HTMLImageElement;
}
//#endregion
export { isDocument, isHTMLAudioElement, isHTMLImageElement, isHTMLMediaElement, isHTMLVideoElement, isShadowRoot };

//# sourceMappingURL=predicates.js.map